module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jhYe45/image/1.png?1695340701631",
      "alt": "This image is the cover for the book The Secret Island"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Secret Island\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Thompson family embark on their annual holiday adventure in Guernsey, where a thrilling quest awaits. Peter, Edward, and Jo, the spirited trio of siblings, set out to explore the island, eager to unravel its mysteries and forge unforgettable memories. Their quest for adventure leads them to a seemingly deserted island, where an unexpected discovery awaits. In the heart of the island, they stumble upon a hidden bungalow—a covert haven for a band of menacing pirates, whose nefarious activities involve attacking passing ships. Amongst the captives is Harriet, a courageous teenage girl kidnapped from a yacht, forced into servitude as the pirates’ cook and cleaner. Driven by bravery and fuelled by their cunning, the children unite with Harriet to outsmart the pirates, a battle of wits and courage that ensues. Together, they hatch a daring plan, alerting the authorities and exposing the pirates’ treachery. Most of the pirates are apprehended, justice prevailing. Yet, the enigmatic leader, known only as The Captain, slips through their grasp, leaving the children and Harriet determined to bring him to justice.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Szemerey\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John Szemerey is a journalist. He was a general and political features writer. He was one of the first British officials of the European Commision (1974 - 2006). He is now retired.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0